<template>
  <vi-page>
    <div class="background-color-white">
      <ul class="nav nav-tabs nav-pills border-0 fs-6 p-3">
        <li class="nav-item pr-2 font-weight-bolder" v-for="tab in tabs" :key="tab.name">
          <a class="nav-link" :class="[tab.name === currentTab.name ? 'active' : '', tab.name === currentTab.name ? '' : 'tab-active']" data-toggle="tab" href="javascript:;" @click="eClick(tab)">{{ tab.label }}</a>
        </li>
      </ul>
    </div>
    <keep-alive v-if="userSN">
      <component :is="currentTab.name" :userSN="userSN"> </component>
      <vi-loading-new v-model="loading"></vi-loading-new>
    </keep-alive>
  </vi-page>
</template>

<script>
import Centre from "./vision/Centre.vue";
import Logs from "./vision/Logs.vue";
export default {
  name: "ApisVision",
  components: {
    Centre,
    Logs,
  },
  data() {
    return {
      loading: true,
      userSN: "",
      currentTab: { name: "Centre", label: "资源调用报表" },
      tabs: [
        { name: "Centre", label: "资源调用报表" },
        { name: "Logs", label: "资源调用日志" },
      ],
    };
  },
  watch: {},
  mounted() {
    this.oGetUser();
  },
  methods: {
    oGetUser() {
      this.$$.api
        .post("/kernel/authentication/apis/biz/user/current")
        .then((res) => {
          this.userSN = res.data.user.sn;
          this.loading = false;
        })
        .catch((e) => {
          this.$$.toastr.error(`错误信息：${e.message}`);
          this.loading = false;
        });
    },
    eClick(tab) {
      if (tab.name !== this.currentTab) {
        this.currentTab = tab;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.background-color-white {
  padding: 16px;
  border-radius: 5px 5px 5px 5px;
  background-color: #ffffff;
}
.tab-active {
  background-color: rgb(232, 233, 238);
}
</style>
